import { ClockIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/components/capstone/base';
import {
  formatDateWithLocalTimezone,
  getLocalTimezoneAbbreviation,
} from '../../../../../utils/dateUtilities';

interface Props {
  timestamp: number;
}

export const DateInformation = ({ timestamp }: Props) => {
  const formattedDate = formatDateWithLocalTimezone(
    timestamp,
    'MMM D, YYYY HH:mm:ss',
  );
  const timezoneAbbreviation = getLocalTimezoneAbbreviation();

  if (!formattedDate) {
    return null;
  }

  return (
    <Box horizontal align="center" marginTop={2}>
      <ClockIcon color="primaryText" width={12} height={12} />
      <Text
        color="primaryText"
        marginLeft={2}
        size="normal"
        lineHeight="normal"
      >
        {formattedDate} {timezoneAbbreviation}
      </Text>
    </Box>
  );
};
